import {Component} from "@angular/core";
import { parseNumber} from 'libphonenumber-js'


@Component({
    selector: 'leasing-user',
    styleUrls: ['./user.scss'],
    templateUrl: './user.html'
})
export class UserComponent {

    public email:string;
    public firstname:string;
    public lastname:string;
    public phone:string;
    public comment:string;

    private emailError:boolean;
    private firstnameError:boolean;
    private lastnameError:boolean;
    private phoneError:boolean;

    public ngOnInit(){
        this.email = "";
        this.firstname = "";
        this.lastname = "";
        this.phone = "";
        this.comment = "";
    }

    public onEmailChanged(){
        if(this.emailError){
            this.emailError = false;
            document.getElementById("email").classList.remove("error");
        }
    }

    public onFirstnameChanged(){
        if(this.firstnameError){
            this.firstnameError = false;
            document.getElementById("firstname").classList.remove("error");
        }
    }

    public onLastnameChanged(){
        if(this.lastnameError){
            this.lastnameError = false;
            document.getElementById("lastname").classList.remove("error");
        }
    }

    public onPhoneChanged(){
        if(this.phoneError){
            this.phoneError = false;
            document.getElementById("phone").classList.remove("error");
        }
    }

    public IsValid():boolean{
        let isValid:boolean = true;
        if(this.firstname.length < 2){
            isValid = false;
            this.firstnameError = true;
            document.getElementById("firstname").classList.add("error");
        }

        if(this.lastname.length < 2){
            isValid = false;
            this.lastnameError = true;
            document.getElementById("lastname").classList.add("error");
        }

        if(!this.IsEmailValid(this.email)){
            isValid = false;
            this.emailError = true;
            document.getElementById("emailId").classList.add("error");
        }

        if(!this.IsPhoneValid(this.phone)){
            isValid = false;
            this.phoneError = true;
            document.getElementById("phone").classList.add("error");
        }

        return isValid;
    }

    public SetEmail(email:string){
        this.email = email;
    }

    public SetFirstname(firstname:string){
        this.firstname = firstname;
    }

    public SetLastname(lastname:string){
        this.lastname = lastname;
    }

    public SetPhone(phone:string){
        this.phone = phone;
    }

    public SetComment(comment:string){
        this.comment = comment;
    }

    public Email():string{
        return this.email;
    }

    public Firstname():string{
        return this.firstname;
    }

    public Lastname():string{
        return this.lastname;
    }

    public Phone():string{
        return this.phone;
    }

    public Comment():string{
        return this.comment;
    }


    private IsEmailValid(email:string):boolean {
        let regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    }

    private IsPhoneValid(phone:string):boolean{
        let parsing = parseNumber(phone, 'BE');
        return parsing.phone != null;
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/user/user.ts